import './AppsSider.less';
import React, { useContext } from 'react';
import AuthLogo, {
    LOGO_APP_CCX_SIDER,
    LOGO_APP_CCX_SIDER_BG,
    LOGO_APP_LABS_BLACK,
    LOGO_APP_LABS_WHITE,
} from './AuthLogo';
import { APP_CCX, CustomAppContext } from './CustomAppContext';
import { useLocation } from 'react-router-dom';

export default AppsSider;

function AppsSider() {
    const { currentApp, getCurrentAppFullName } = useContext(CustomAppContext);

    const location = useLocation();

    const pages = ['/privacy-policy', '/terms-and-conditions'];

    const getSiderText = () => {
        return <>Welcome to</>;
    };

    return (
        <div className="AppsSider">
            <div className="AppsSider-wrapper">
                <div style={{}} className="AppsSider-wrapper-top">
                    <div
                        className="AppsSider-wrapper-top-text"
                        style={{
                            color: '#ffffff',
                        }}
                    >
                        {getSiderText()}
                    </div>
                    <AuthLogo currentApp={LOGO_APP_CCX_SIDER} className="" />
                </div>

                <div
                    style={{
                        paddingBottom: '40px',
                        color: currentApp === APP_CCX ? '#ffffff' : '#2B2929',
                    }}
                >
                    <div className="AppsSider-logo-labs">
                        <AuthLogo
                            currentApp={LOGO_APP_LABS_WHITE}
                            className=""
                        />
                    </div>
                    <div>
                        © Copyright Severalnines {new Date().getFullYear()}. All
                        rights reserved.
                    </div>
                </div>
            </div>
        </div>
    );
}
